import moment from "moment-timezone";
import es from "moment/src/locale/es";

moment.defineLocale("es", es._config);
moment.locale("es");

const TENERIFE_SUR = 18;

export function getTimezone() {
  const store = window.store;
  if (store.getters["app/callCenter"] && store.getters["app/callCenter"].id === TENERIFE_SUR) {
    return "Atlantic/Canary";
  }
  return "Europe/Madrid";
}

export default () => {
  moment.tz.setDefault(getTimezone());
  return moment;
};
